import { ChangeDetectionStrategy, Component, Inject, Optional } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '../../devices.models';

@Component({
    selector: 'liebherr-edit-devices-dialog',
    templateUrl: 'edit-devices-dialog.component.html',
    styleUrls: ['edit-devices-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditDevicesDialogComponent {
    singleForm = this.fb.group({
        craneId: [undefined, Validators.maxLength(255)],
    });

    constructor(
        public dialogRef: MatDialogRef<EditDevicesDialogComponent>,
        private fb: UntypedFormBuilder,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: { device: Router }
    ) {
        this.singleForm.patchValue({ craneId: this.data?.device?.craneId });
    }

    onCancel() {
        this.dialogRef.close();
    }
    onSubmit() {
        if (this.singleForm.valid) {
            this.dialogRef.close(this.singleForm.getRawValue());
        }
    }
}
